import React, { useMemo } from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

const BarChartOutput = ({ descriptor, data }) => {
  const chartData = useMemo(() => {
    if (!data?.length) return []

    if (descriptor.groupBy === 'month') {
      const grouped = data.reduce((acc, row) => {
        const month = String(row[descriptor.dateField] ?? '').substring(0, 7)
        if (month) acc[month] = (acc[month] || 0) + 1
        return acc
      }, {})
      return Object.entries(grouped)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([month, count]) => ({ month, count }))
    }

    return data
  }, [data, descriptor.groupBy, descriptor.dateField])

  if (!chartData.length) return null

  return (
    <div>
      {descriptor.label && (
        <h3 className="text-sm font-medium text-gray-700 mb-2">{descriptor.label}</h3>
      )}
      <ResponsiveContainer width="100%" height={250}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Bar dataKey={descriptor.dataKey || 'count'} fill="#7c3aed" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

export default BarChartOutput
